import { render, staticRenderFns } from "./flex-custom-table.vue?vue&type=template&id=293592ea&scoped=true"
import script from "./flex-custom-table.vue?vue&type=script&lang=js"
export * from "./flex-custom-table.vue?vue&type=script&lang=js"
import style0 from "./flex-custom-table.vue?vue&type=style&index=0&id=293592ea&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "293592ea",
  null
  
)

export default component.exports